<template>
  <div class="preferences">
    <div class="greeting">
      היי {{ householdName }}!
    </div>
    <div class="greeting-subtext">
      כדי לבנות תזרים אוטומטי, המערכת צריכה את הפרטים של חשבונות הבנק וכרטיסי האשראי:
    </div>
    <credentials-selection-card class="credentials-card"
                                :firstSelectionText="'באיזה בנק החשבון?'"
                                :action="setFinishedAddingBanks"
                                :selectedSources="bankSourcesToAdd"
                                :addSource="addSourceBank"
                                :scrollable="true"
                                :sourceType="'bank'"
                                :removeSource="removeSourceBank"/>
    <credentials-selection-card class="credentials-card"
                                :firstSelectionText="'באיזו חב׳ אשראי החשבון?'"
                                :disabled="!finishedAddingBanks"
                                :action="setFinishedAddingCards"
                                :selectedSources="cardSourcesToAdd"
                                :addSource="addSourceCard"
                                :scrollable="false"
                                :sourceType="'card'"
                                :removeSource="removeSourceCard"/>
    <div class="greeting-subtext">לפני שנמשיך, חשוב לקרוא על אבטחת המידע שלנו:</div>
    <security-agreement-card :disabled="!finishedAddingBanks" :saving="saving" :action="saveSourcesAndUserAgreement"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import CredentialsSelectionCard from '../../../../../base-components/credentials/credentials-selection-card/CredentialsSelectionCard.vue';
import SecurityAgreementCard from './SecurityAgreementCard.vue';
import Segment from '../../../../../Segment';

export default {
  name: 'Preferences',
  components: {
    SecurityAgreementCard,
    CredentialsSelectionCard,
  },
  async created() {
    await this.fetchUserAgreed();
    Segment.trackUserGot('PreferenceEntered');
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
    };
  },
  computed: {
    ...mapState('onboardPreferences', ['userAgreed']),
    ...mapState('selectedSources', [
      'cardSourcesToAdd',
      'bankSourcesToAdd',
      'finishedAddingCards',
      'finishedAddingBanks',
    ]),
    ...mapGetters('credentials', ['hasCredentials']),
    ...mapGetters('session', ['householdName']),
  },
  methods: {
    ...mapActions('onboardPreferences', ['setSelectedBanks', 'setSelectedCards', 'setUserAgreed', 'fetchUserAgreed']),
    ...mapActions('selectedSources', [
      'setFinishedAddingCards',
      'setFinishedAddingBanks',
      'addSourceCard',
      'removeSourceCard',
      'addSourceBank',
      'removeSourceBank',
      'createCreds',
    ]),
    async saveSourcesAndUserAgreement() {
      this.saving = true;
      Segment.trackUserInteraction('PreferenceDoneClicked');
      Segment.trackUserInteractionToPixel('PRD');
      await this.createCreds();
      this.setUserAgreed({ userAgreed: true });
      this.next();
      this.saving = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .preferences {
    margin: 30px;

    .greeting {
      @include title;
    }

    .greeting-subtext {
      font-size: 20px;
      margin: 4px auto 16px;
      line-height: 1.2em;
    }

    .credentials-card {
      margin-bottom: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard/steps/Preferences.vue